<script lang="ts" setup>
import DefaultWrapper from "~/common/layouts/default-wrapper.vue";
</script>

<template>
  <DefaultWrapper>
    <NuxtPage />
  </DefaultWrapper>
</template>
